import React from 'react'
import Icon from 'meinian-package/src/component/icon'
import { isPermissions } from 'meinian-package/src/utils/auth'
import util from 'meinian-package/src//utils/util'
import { MARK_STATUS, IDEA_MASS_ROLE, getMarkStatusText } from 'meinian-package/src/component/enum'
import noteRemind from '../../useFunModal/noteRemind'
import Examine from '../../examine'
import './cardExamine.less'

export default ({
  materialFlag,
  hasMarkPermissions,
  data,
  outerIndex,
  onItemDataChange,
  trackModule2,
  onCommentVisible,
  onInitiativeBehavior,
  blogComment,
  onChange,
  itemData,
  onDeleteItem,
  onResize,
  initSubColls,
}) => {
  const renderDom = () => {
    if (!materialFlag && hasMarkPermissions) {
      return <Examine
        currentBlog={itemData}
        onDeleteItem={onDeleteItem}
        onResize={onResize}
        initSubColls={initSubColls}
        trackModule2={trackModule2}
        wrapperClassName="card-examine"
        onChange={(markStatus, markTimes) => {
          data[outerIndex].markStatus = markStatus
          data[outerIndex].markTimes = markTimes
          onChange?.(true, { markTimes, markStatus })
          if (window.location.pathname.startsWith('/meinian/home/workbench')) {
            util.track('mn-workbench-click', {
              module1: '款式查看',
              module2: trackModule2,
              module3: '审核操作',
            })
          }
          onItemDataChange()
        }}
        onInitiativeBehavior={onInitiativeBehavior}
        onCommentVisible={onCommentVisible}
      />
    }
    if (isPermissions(itemData.loginUserInfo?.inspirationPermissions, ['FS07', 'FS07_CREATOR', 'FCS08', 'FCS08_CREATOR']) && itemData.loginUserInfo?.role === IDEA_MASS_ROLE.GATHER) {
      return <div className="mn-card-examine-wrapper">
        {itemData.markStatus === MARK_STATUS.NOT_PASS ? <>
          <Examine.Delete
            trackModule2={trackModule2}
            loginUserInfo={itemData.loginUserInfo}
            imageGroupEntityId={itemData.imageGroupEntityId}
            inspirationId={itemData.inspirationId}
            platformId={itemData.platformId}
            onDeleteItem={onDeleteItem}
            onResize={onResize}
            initSubColls={initSubColls}
            style={{ flex: 1 }}
          />
          {
            !!blogComment.length && <Examine.LeaveComment
              style={{ marginLeft: '8px', flex: 1 }}
              onClick={(e) => {
                e.stopPropagation()
                onInitiativeBehavior(true)
                onCommentVisible?.(pre => !pre)
              }}
            />
          }
        </> : null}
        {(itemData.markStatus === MARK_STATUS.UNSET) && <Examine.Commit
          currentBlog={itemData}
          style={{ flex: 1 }}
          onChange={(markStatus, markTimes) => {
            data[outerIndex].markStatus = markStatus
            data[outerIndex].markTimes = markTimes
            onChange?.(true, { markTimes, markStatus })
            if (window.location.pathname.startsWith('/meinian/home/workbench')) {
              util.track('mn-workbench-click', {
                module1: '款式查看',
                module2: trackModule2,
                module3: '审核操作',
              })
            }
            onItemDataChange()
          }}
        >提交审核</Examine.Commit>}
        {(itemData.markStatus === MARK_STATUS.PENDING) && <div className="meinian-examine-commit-button-recall">
          {
            isPermissions(itemData.loginUserInfo?.inspirationPermissions, ['FS18_CREATOR']) && <Icon
              type="m-duanxin"
              className="meinian-examine-commit-button-recall-icon"
              style={{ marginRight: '8px' }}
              onClick={(e) => {
                e.stopPropagation()
                noteRemind({
                  option: {
                    userName: itemData.userName,
                    collectId: itemData.collectId,
                    inspirationId: itemData.inspirationId,
                  },
                })
              }}
            />
          }
          <Examine.Recall
            style={{ flex: 1 }}
            currentBlog={itemData}
            onChange={(markStatus, markTimes) => {
              data[outerIndex].markStatus = markStatus
              data[outerIndex].markTimes = markTimes
              onChange?.(true, { markTimes, markStatus })
              if (window.location.pathname.startsWith('/meinian/home/workbench')) {
                util.track('mn-workbench-click', {
                  module1: '款式查看',
                  module2: trackModule2,
                  module3: '审核操作',
                })
              }
              onItemDataChange()
            }}
          />
        </div>}
        {getMarkStatusText(itemData.markStatus, { isPass: true, maxLevel: itemData.needMarkTimes, level: itemData.markTimes }) && <Examine.Sample
          onChange={(markStatus, markTimes) => {
            data[outerIndex].markStatus = markStatus
            data[outerIndex].markTimes = markTimes
            onChange?.(true, { markTimes, markStatus })
            if (window.location.pathname.startsWith('/meinian/home/workbench')) {
              util.track('mn-workbench-click', {
                module1: '款式查看',
                module2: trackModule2,
                module3: '审核操作',
              })
            }
            onItemDataChange()
          }}
          style={{ flex: '1' }}
          inspirationId={itemData.inspirationId}
          loginUserInfo={itemData.loginUserInfo}
          imageGroupEntityId={itemData.imageGroupEntityId}
          platformId={itemData.platformId}
          collectId={itemData.collectId}
        />}
      </div>
    }
  }

  return <>
    {renderDom()}
  </>
}
